import { getDepartmentsData, departmentMap } from './process';
var OperateWorker = { getDepartmentsData: getDepartmentsData, departmentMap: departmentMap };
function getResult(fn, data) {
    return OperateWorker[fn](data);
}
export default getResult;
